import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "header" }
const _hoisted_2 = { class: "header-shell" }
const _hoisted_3 = { class: "brand-lockup" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "brand-mark" }, "VS", -1)
const _hoisted_5 = { class: "hero-kicker" }
const _hoisted_6 = {
  class: "signal-panel",
  "aria-label": "实时监控"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "signal-dot" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("strong", null, "Live", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.host), 1),
          _createElementVNode("h1", null, _toDisplayString(_ctx.header), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.subHeader), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", null, [
          _hoisted_8,
          _createElementVNode("span", null, _toDisplayString(_ctx.interval) + "s refresh", 1)
        ])
      ])
    ])
  ]))
}